angular.module 'zc.master.users'

.config ($stateProvider) ->
  $stateProvider
  .state 'admin.master.users',
    url: '/users'
    views:
      'content@':
        templateUrl: '/templates/master.users/list.html'
        controller: 'MasterUsersCtrl'



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.users/routes.js.coffee